import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { ImageCropData, PopupData, Service } from 'webapp-types';

export interface Args {
	image?: string;
	originalImage?: string;
	imageCrop?: ImageCropData | null;
	canEdit?: boolean;
	onChange: (url: string, originalUrl: string, crop: ImageCropData | null) => void;
}

export default class FileLogoWithUploadComponent extends Component<Args> {
	@service('popup') declare popupService: Service.Popup;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('account') declare accountService: Service.Account;

	get isDefaultImage() {
		return this.args.image === this.accountService.boardLogo;
	}

	@action
	openLogoOptions(): void {
		if (!this.args.canEdit) {
			return;
		}

		const onFinish: PopupData.Common.ImageUpload['onFinish'] = (url, originalUrl, crop) => {
			this.args.onChange(url, originalUrl, crop);
		};

		// old boards might not have original saved, so we must edit the cropped
		const image = this.isDefaultImage ? '' : this.args.originalImage || this.args.image;
		this.navigationService.openImageUploadPopup(onFinish, '', image, this.args.imageCrop);
	}

	<template>
		<img
			role="button"
			class="logo"
			src={{@image}}
			alt={{if @canEdit "Click to edit"}}
			{{on "click" this.openLogoOptions}}
		/>
	</template>
}
